// Helper functions for calculating horizontal scroll settings

// Calculate scroll settings based on the number of items (stakeholders, categories, etc.)
// Returns an object with isScrollable flag and calculated chartWidth
export const calculateHorizontalScrollSettings = ({ itemCount, maxVisibleItems = 8, widthPerItem = 70 }) => {
  if (itemCount > maxVisibleItems) {
    return {
      isScrollable: true,
      chartWidth: itemCount * widthPerItem
    }
  }

  return {
    isScrollable: false,
    chartWidth: null
  }
}
